export default __webpack_public_path__ + "static/media/check-icon.d54282cb.webp";